import { createIcon } from '@chakra-ui/react';

export const PinIcon = createIcon({
	viewBox: '0 0 13 14',
	d: 'M8.6269.9913a.6949.6949 0 0 0-.9827.9827l.27.2701-4.308 3.4556-.5387-.5388a.6948.6948 0 1 0-.9827.9827l2.1499 2.1499-4.033 4.0318a.6881.6881 0 1 0 .9731.9731l4.0317-4.033 2.15 2.1498a.6947.6947 0 0 0 .9826 0 .6948.6948 0 0 0 0-.9826L7.86 9.9534l3.4081-4.3555.2579.2579a.6949.6949 0 0 0 .9827-.9827L8.6269.9913Zm.2673 2.249 1.3763 1.3763L6.933 8.8853 4.673 6.6254l4.2211-3.385Z',
});
